import { BusinessHours } from '../calendar/businessHours';
export class CompanyConfigurationDto {
  businessHoursActive?: boolean;
  businessHours?: BusinessHours[];
  assignmentMethod?: string;
  timeZone?: string;
  timeForConcurrence?: number;
  trackingEmail?: boolean;
  leadinLive?: boolean;
  testAb?: boolean;
  dropdownWithRules: boolean;
  logoPath: string;
}
